module.exports = __webpack_public_path__ + "pipeBody.png?33facffd6fd7b871b211c8749978d696";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pipeBody.png
// module id = 5
// module chunks = 0